<template>
  <div v-if="currentRoute">
    <div v-if="!sideNavNotAllowedRoute.includes(currentRoute)">
      <div>
        <SideNav />
        <div class="main-content" id="panel">
          <Header />
          <router-view />
          <Footer />
        </div>
      </div>
    </div>
    <div v-if="sideNavNotAllowedRoute.includes(currentRoute)" class="login">
      <router-view />
    </div>
    <notifications group="foo" position="bottom right" classes="notify" />
    <!-- <TraderNotification/> -->
  </div>
</template>

<script>
import SideNav from "./components/common/SideNav";
import axios from "axios";
import authService from "@/authService";
import Header from "./components/common/Header";
import Footer from "./components/common/Footer";
import config from "@/config";

// import TraderNotification from "./components/bidside/trader/TraderNotification"

export default {
  name: "App",
  components: {
    SideNav,
    Header,
    Footer,
    // TraderNotification
  },
  data(){
    return {
      sideNavNotAllowedRoute : [
       'login',
       'reset',
       'forgotpassword',
       'report',
       'dashboardoption',
       'bidacceptorreject',
       'printticket'
      ],
      currentRoute : null

    }
  },
  methods: {
    logout: function() {
      this.$cognitoAuth.logout();
      this.$router.push({ path: "/" });
    },
    sendTraderNotification(){
      const auth = {};
      let data = {
          "type":"traderNotification",
          "cognito":authService.getUser().cognitoSub
      }
      this.$http
        .post(
           config.baseUrlAutoBidder +
            "/in-memory",data,
            auth
        )
        .then(() => {
          
        })
        .catch(e => {
          console.log(e);
        });
    },
  },
  created() {
     this.$watch(
      () => this.$route,
      (route) => {
        this.currentRoute = route.name;
        //unwatch();
      });
    // Add a response interceptor
    var self = this;
    axios.interceptors.response.use(
      function(response) {
        // Any status code that lie within the range of 2xx cause this function to trigger
        // Do something with response data
        //console.log("Axios",response);
        return response;
      },
      function(error) {
        // Any status codes that falls outside the range of 2xx cause this function to trigger
        // Do something with response error
        //console.log(error.response.data.message)
        if (error.response.status == 401) {
          self.logout();
        }
        if (error.response.status == 400 || error.response.status == 404 ||  error.response.status == 500 ) {
          self.$alert("Oops!! something went wrong. Please try again","","error");
          
        }
        if(error.response.status == 504){
          self.$alert("504 Gateway Time-out.","","warning");
        }
        if (error.response.status == 422) {
          self.$alert(error.response.data.message,"","warning");
          self.sendTraderNotification();
        }
        return Promise.reject(error);
      }
    );
    // Add a request interceptor
    axios.interceptors.request.use(function (config) {

       let myPromise = new Promise(function(myResolve, myReject) {
          self.$cognitoAuth.getIdToken((err, result) => {
            if (err) {
              console.log("accessToken is not found", err);
              myReject("accessToken is not found")
            } else {
                myResolve(result);
            }
          });
        });
        return myPromise.then(function(value) {
          config.headers.authorization = value;
          return config;
        },function(){
          self.logout();
        });
    });
    // set Access token

    // this.$cognitoAuth.getIdToken((err, result) => {
    //   if (err) {
    //     console.log("accessToken is not found", err);
    //   } else {
    //        axios.defaults.headers.common['authorization'] = result;

    //   }
    // });
    //console.log("my axios", axios.interceptors)
  },
  mounted(){
    if(!this.isDev) console.log = ()=>{};
  }
};
</script>

<style>
@import "./assets/css/drl-style.css";
@import "./assets/css/style.css";
@import "~vue-wysiwyg/dist/vueWysiwyg.css";
</style>